"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyTradeHistory = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var zl_1 = require("../../model/zl");
var service_1 = require("../../../library/base/service");
var MyTradeHistory = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(MyTradeHistory, _super);
    function MyTradeHistory() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '基金历史记录';
        _this.code = '106014';
        _this.desc = '基金历史记录';
        _this.requestParams = new zl_1.MyTradeHistoryRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return MyTradeHistory;
}(service_1.BaseService));
exports.MyTradeHistory = MyTradeHistory;
//# sourceMappingURL=myTradeHistory.js.map